import React, { useState } from 'react';
import { FaRegEdit } from 'react-icons/fa';
import { TiCancel } from 'react-icons/ti';
import { Button } from '../design-system';

interface EditButtonProps {
  onClick?: () => void;
  fontSize?: number;
  toggleEdit: (val: boolean) => void;
  [key: string]: any;
}

const EditButton = ({
  onClick,
  fontSize,
  toggleEdit,
  ...props
}: EditButtonProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const handleEdit = () => {
    const value = !isEditing;
    setIsEditing(value);
    toggleEdit(value);
  };

  return (
    <Button
      id="edit-button"
      title="Edit"
      type="button"
      aria-label="Edit Item"
      variant="primaryText"
      onClick={() => handleEdit()}
      {...props}
    >
      {isEditing ? (
        <TiCancel fontSize={fontSize || 20} />
      ) : (
        <FaRegEdit fontSize={fontSize || 20} />
      )}
    </Button>
  );
};

export default EditButton;
